import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AnalyticsChartModel from "../../models/analytics-chart";

function stripApiPrefix(url) {
  if (!url) {
    return "";
  }
  return String(url).replace(/^\/?api\//, "").replace(/^\/api\//, "").replace(/^\/?/, "");
}

export default class AnalyticsChartRepository extends BaseRepository {
  static modelClass = AnalyticsChartModel;
  modelName = "analytics-chart";

  async fetchByUrl(resultsUrl, filters = null) {
    const params = filters instanceof URLSearchParams ? filters.toString() : "";
    const separator = String(resultsUrl || "").includes("?") ? "&" : "?";
    const urlWithFilters = params ? `${resultsUrl}${separator}${params}` : resultsUrl;
    const urlPath = stripApiPrefix(urlWithFilters);
    return await super.query({ urlPath });
  }
}

